<fieldset [formGroup]="form" class="lots-table">
  <div class="first-field">
    <mat-form-field appearance="outline" class="date-picker">
      <mat-label>Total Number of Proposed Lots</mat-label>
      <input
        id="lotsProposed"
        mask="0*"
        maxlength="3"
        matInput
        placeholder="Type number of lots"
        [formControl]="count"
        (change)="onChangeLotCount($event)"
        [required]="true"
      />
      <span matTextSuffix>lots</span>
    </mat-form-field>
  </div>

  <div class="full-row">
    <label class="subheading2">Approved Lot Areas</label>
    <table mat-table [dataSource]="lotsSource">
      <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef class="subheading2">#</th>
        <td mat-cell *matCellDef="let i = index">{{ i + 1 }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef class="subheading2">Type</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-form-field appearance="outline">
            <mat-select placeholder="Please select" formControlName="{{ i }}-lotType" (selectionChange)="fireChanged()">
              <mat-option value="Lot"> Lot </mat-option>
              <mat-option value="Road Dedication"> Road Dedication </mat-option>
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="size">
        <th mat-header-cell *matHeaderCellDef class="subheading2">Size (ha)*</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-form-field appearance="outline">
            <input
              type="text"
              matInput
              thousandSeparator=","
              mask="separator.5"
              separatorLimit="9999999999"
              min="0.01"
              formControlName="{{ i }}-lotSize"
              (change)="fireChanged()"
            />
            <span matTextSuffix>ha</span>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="alrArea">
        <th mat-header-cell *matHeaderCellDef class="subheading2">ALR Area (ha)*</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-form-field appearance="outline">
            <input
              type="text"
              matInput
              thousandSeparator=","
              mask="separator.5"
              separatorLimit="9999999999"
              min="0.01"
              formControlName="{{ i }}-lotAlrArea"
              (change)="fireChanged()"
            />
            <span matTextSuffix>ha</span>
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="uuid" hidden>
        <th mat-header-cell *matHeaderCellDef>uuid</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <mat-form-field appearance="outline">
            <input type="text" matInput formControlName="{{ i }}-lotUuid" />
          </mat-form-field>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row no-data" *matNoDataRow>
        <td class="text-center" colspan="7">No Proposed Lots Entered</td>
      </tr>
    </table>
  </div>
</fieldset>
